$(document).ready(function () {
  $(document).on('click', '.faqs__item-title-box', function() {
    $(this).toggleClass('active');
    var $nextElement = $(this).next();

    if ($nextElement.hasClass('active')) {
      $nextElement.slideUp(200, function () {
        $(this).toggleClass('active');
      });
    } else {
      $nextElement.slideDown(200, function () {
        $(this).toggleClass('active');
      });
    }
  });
});